// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Z42c","question":"styles_question__1SvHs","inputVisibleButton":"styles_inputVisibleButton__1dwG0","note":"styles_note__3vrlU"};